import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { jobEndpoints, appointmentAuthEndpoints } from '@/lib/api/endpoints';
import { jobKeys, isJobAppointmentsQuery } from '@/lib/queryKeys';
import type { AuthorizationMethod } from '@/types/job';

export interface CollectAuthorizationDto {
  method: AuthorizationMethod;
  authorizedBy: string;
  signatureUrl?: string;
  ipAddress?: string;
  notes?: string;
}

export function useCollectAuthorization(entity: 'job' | 'appointment' = 'job') {
  const qc = useQueryClient();
  return useApiMutation<unknown, CollectAuthorizationDto & { id: string }>({
    mutationFn: ({ id, ...dto }) => {
      const url =
        entity === 'job'
          ? jobEndpoints.authorizationCollect(id)
          : appointmentAuthEndpoints.authorizationCollect(id);
      return apiPost(operationsClient, url, dto);
    },
    onSuccess: (_data, vars) => {
      if (entity === 'job') {
        void qc.invalidateQueries({ queryKey: jobKeys.detail(vars.id) });
      } else {
        // The mutation only carries the appointment id, not its jobId, so match
        // any cached job-appointments list/detail query and refetch it.
        void qc.invalidateQueries({ predicate: isJobAppointmentsQuery });
      }
      toast.success('Authorization recorded');
    },
  });
}
